/* eslint-disable import/first */
import React, { useState } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { Button, Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { useNavigate, useLocation } from '@reach/router';
import ClassNames from 'classnames';
import { TiTick } from '@react-icons/all-files/ti/TiTick';
import { FormattedMessage, useIntl } from 'react-intl';
import { isProductCustomized } from 'spwa-ui-library/esm/utils/helper';
import css from './index.module.scss';
import { generateProductRoute } from 'spwa-ui-library/esm/utils/path';

const { getClusterId } = Slices.configSlice;
const { selectDesktop } = Slices.appSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const {
  selectProductEntities,
  addNewProduct,
  getProductInfo,
  fetchProductsByCategoryId,
} = Slices.productSlice;
const { reduceItem, updateWithIndex, addWithoutCalculation } = Slices.cartSlice;
const {
  addProductToCustomize,
  updateProductPayload,
  addPayloadToTempData,
  addProductToPrevCustomization,
} = Slices.tempCartSlice;
import deleteIcon from '../ProductTileCart/images/delete.svg';

const Addtocart = ({
  qty,
  isBundleItem,
  stepId,
  currentStepId,
  currency,
  onIncrement,
  productObj,
  onDecrement,
  load,
  productRoute,
  returnURL,
  mainProductId,
  setShowBundleGroupDialog,
  setCurrentStepperId,
  setShowCustomizeProductDialog,
  setShowCartDialog,
}) => {
  const isDesktop = useSelector(selectDesktop);
  const dispatch = useDispatch();
  let location = useLocation();
  const [alertMessage, setAlertMessage] = useState('');
  const clusterId = useSelector(getClusterId);
  const defaultAddress = useSelector(selectDefaultAddress);
  const locationSearch = new URLSearchParams(location.search);
  const tempItems = useSelector((state) => state.tempCart);
  const bogoProducts = useSelector((state) => state.product.bogoProdList);
  const cartItems = useSelector((state) => state.cart);
  const categoryList = useSelector((state) => state.category);
  const productsMap = useSelector(selectProductEntities);
  const navigate = useNavigate();
  const intl = useIntl();
  let bundleItemPrice = 0;
  const buttonProps = isDesktop ? { variant: 'outlined' } : { variant: 'contained' };

  let productCustomization = tempItems?.data?.items?.find(
    (item) => item.id == (mainProductId || productObj.id)
  );

  let isCustomized = tempItems.customize.items.filter(
    (product) => product?.id == productObj?.id && !product?.notAdded
  );

  let prodCust = tempItems.customize.items.find((product) => product?.id == productObj?.id);
  if (prodCust && productObj?.typeId == 'simple' && productObj?.bundleTypeId == 'bundle') {
    isCustomized = !prodCust?.isDefault;
  }

  if (isBundleItem) {
    qty =
      (productsMap[mainProductId]?.typeId == 'simple'
        ? productCustomization?.['items']?.[currentStepId]?.[productObj?.id]?.['qty'] ||
          productCustomization?.['bundle']?.[currentStepId]?.[productObj?.id]?.['qty']
        : productCustomization?.['bundle']?.[currentStepId]?.[productObj?.id]?.['qty']) || 0;
  }

  // check is button needs to be disabled
  let shouldDisabledButton;
  if (isBundleItem) {
    const currentStepInfo = productsMap[mainProductId]?.steps?.find(
      (step) => step?.id == currentStepId
    );
    let productStructure = productCustomization?.['items']
      ? productCustomization?.['items']
      : productCustomization?.['bundle'];
    const currentStepProductsCount =
      Object.values(productStructure?.[currentStepId] || {})?.reduce((totalQty, product) => {
        return totalQty + (product?.notAdded ? 0 : product?.qty || 1);
      }, 0) || 0;

    if (currentStepProductsCount >= (currentStepInfo?.maximum || 1)) {
      shouldDisabledButton = true;
    } else {
      shouldDisabledButton = false;
    }
  }

  const itemExistsInCart = () => {
    // TODO fix this code for SPWAP-2491
    // let data = tempItems?.customize?.items?.find(
    //   (item) => item.id == (mainProductId || productObj.id)
    // );
    let data = tempItems?.customize?.items?.find((item) => item.id == productObj.id);

    return (
      !!data && (!!data['items'] || !!data['bundle'] || !!data['subItem']) && data?.isCustomized
    );
  };

  const handleHomePageItem = () => {
    dispatch(
      fetchProductsByCategoryId({
        id: productObj?.categories[0],
        cluster: clusterId,
        Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
      })
    ).then((p) => {
      dispatch(
        getProductInfo({
          id: productObj?.id,
          cluster: clusterId,
          service: defaultAddress?.addressSubType || 'DELIVERY',
          categoryId: productObj?.categories[0],
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      ).then((resp) => {
        if (resp?.payload?.id) {
          dispatch(addNewProduct(resp.payload));
        }
        const productData = resp.payload;
        let category = {};
        let locale = intl.locale;
        let productRoute = '';
        category = categoryList.entities[productData?.categories?.[0]];
        productRoute = generateProductRoute({ product: productData, category, locale });
        if (
          (productData?.bundleTypeId === 'bundle' ||
            productData?.bundleTypeId === 'bundle_group') &&
          productData?.typeId != 'simple'
        ) {
          productRoute = `${productRoute}/bundle`;
        }
        dispatch(
          addProductToCustomize({
            productType: productData?.bundleTypeId,
            updatedOn: new Date().getTime(),
            mainProductId: productData?.id,
            data: {
              ...productData,
              noIncrement: true,
            },
          })
        );
        navigate(productRoute, {
          state: {
            retUrl: `/${intl.locale}/home/`,
            oldLocation: location,
            description: `${productObj?.name || productObj?.title || ''}`,
          },
        });
      });
    });
  };

  const handleAction = (e) => {
    if (productObj?.isHomePageItem && qty == 0) {
      handleHomePageItem();
      return;
    }

    if (isCustomized) {
      window.localStorage.setItem('notShowBogoPopup', false);
    }

    if (productRoute?.includes('/bundle') && !currentStepId) {
      window.localStorage.removeItem('unlockedStepperId');
    }

    let isCustomizedBundleItem = false;
    let productCustomization = tempItems.data.items.find(
      (product) => product.id == (mainProductId || productObj?.id)
    );

    if (!isBundleItem && !productCustomization && isCustomized?.length) {
      productCustomization = tempItems.customize.items.find(
        (product) => product.id == (mainProductId || productObj?.id)
      );
    }

    let allProducts = [];
    for (let [sId, step] of Object.entries(productCustomization?.['bundle'] || {})) {
      for (let [pId, pObj] of Object.entries(step)) {
        allProducts = [...allProducts, { ...pObj, id: pId, sId: sId }];
      }
    }
    let matches = allProducts?.filter((item) => item.id == productObj.id && !item?.notAdded);
    let actualMatches = [];
    for (let match of matches) {
      let doesVariationExist = true;
      for (let [variantId, selectedVariant] of Object.entries(match?.variants || {})) {
        // check if this combo exists in productObj or not
        let currentVariation = productObj?.variants?.find((v) => v.id == variantId);
        let currentSelectedVariation = currentVariation?.options?.find(
          (cv) => cv.id == selectedVariant
        );

        if (!currentSelectedVariation) {
          doesVariationExist = false;
        }
      }

      if (doesVariationExist) {
        actualMatches.push(match);
      }
    }
    matches = actualMatches;

    const isLastDefault = matches[matches.length - 1]?.isDefault;

    let customizedIndex = 0;
    for (let i = 0; i < matches.length; i++) {
      if (matches[i]?.items && !matches[i]?.isDefault) {
        customizedIndex = i;
      }
    }

    isCustomizedBundleItem =
      matches.length > 0 &&
      !isLastDefault &&
      !productCustomization?.['bundle']?.[currentStepId]?.[productObj?.id]?.['notAdded'] &&
      Object.keys(matches[customizedIndex]?.items || {}).length > 0 &&
      isProductCustomized(productObj, matches[customizedIndex]);

    if (isBundleItem && isCustomizedBundleItem) {
      console.log(`showing 1`);
      setShowCustomizeProductDialog(productObj.id);
    } else if (
      itemExistsInCart() &&
      (productObj['typeId'] != 'simple' || (productObj['typeId'] == 'simple' && isCustomized)) &&
      setShowCustomizeProductDialog
    ) {
      console.log(`showing 2`);
      setShowCustomizeProductDialog(mainProductId || productObj.id);
    } else if (
      productObj?.bundleTypeId == 'bundle_group' ||
      (productObj?.typeId == 'bundle_group' && setShowBundleGroupDialog)
    ) {
      setShowBundleGroupDialog(mainProductId || productObj.id);
    } else if (!productRoute) {
      if (isBundleItem) {
        let availableSteps;

        if (locationSearch.has('bundleGroup')) {
          let selectedDealVariant = productsMap[mainProductId]?.items?.find(
            (item) =>
              item['id'] == locationSearch.get('option') ||
              item['sel1Value'] == locationSearch.get('option')
          );
          availableSteps =
            productsMap[selectedDealVariant?.id]?.steps?.filter((step) => !step?.isHidden) ||
            selectedDealVariant?.steps?.filter((step) => !step?.isHidden);
        } else {
          availableSteps = productsMap[mainProductId]?.steps?.filter((step) => !step?.isHidden);
        }
        const completedStep = window.localStorage.getItem('unlockedStepperId') || currentStepId;
        if (completedStep) {
          const stepIndex = availableSteps?.findIndex((step) => step?.id == completedStep);
          let newStepUnlockedId, newStepId;
          if (stepIndex == availableSteps?.length - 1) {
            newStepUnlockedId = availableSteps[stepIndex]?.id;
            newStepId = completedStep;
          } else {
            newStepUnlockedId = availableSteps?.[stepIndex + 1]?.id;
            newStepId = availableSteps?.[stepIndex + 1]?.id;
          }

          let completedSteps = Object.keys(productCustomization?.['bundle'] || {});
          let i = stepIndex + 1;
          while (i < availableSteps?.length) {
            if (completedSteps.includes(availableSteps?.[i]?.id.toString())) {
              newStepUnlockedId = availableSteps?.[i + 1]?.id || availableSteps[i]?.id;
            } else {
              break;
            }
            i += 1;
          }

          const completedStepInfo = availableSteps?.find(
            (avlblStep) => avlblStep.id == currentStepId
          );
          const minimumOptionsRequired = Math.min(
            completedStepInfo?.minimum || 1,
            completedStepInfo?.options?.length || 1
          );

          const completedStepCount = Object.keys(
            productCustomization?.['bundle']?.[currentStepId] || {}
          )?.length;

          if (
            completedStepCount + 1 >= minimumOptionsRequired &&
            currentStepId >= parseInt(completedStep)
          ) {
            console.log(`1. setting completedStep - `, parseInt(completedStep));
            console.log(`1. setting unlockedStepperId - `, parseInt(newStepUnlockedId));
            window.localStorage.setItem('completedStep', parseInt(completedStep));
            window.localStorage.setItem(`unlockedStepperId`, parseInt(newStepUnlockedId));
          } /*else {
            const prevStepId =
              availableSteps[
                availableSteps?.findIndex((avlblStep) => avlblStep.id == currentStepId) - 1
              ]?.id;
            window.localStorage.setItem('completedStep', parseInt(prevStepId));
            console.log(`2. setting unlockedStepperId - `, parseInt(currentStepId));
            window.localStorage.setItem(`unlockedStepperId`, parseInt(currentStepId));
          }*/
        }
      } else {
        if (!productCustomization) {
          dispatch(
            addProductToCustomize({
              productType: productObj.bundleTypeId,
              updatedOn: new Date().getTime(),
              mainProductId: productObj.id,
              data: {
                ...productsMap[productObj.id],
                noIncrement: true,
              },
            })
          );
        } else if (isCustomized?.length > 0) {
          const productId = isCustomized[0]?.id;
          const variations = [-1, -1, -1];

          Object.values(isCustomized[0]?.variants || {}).forEach((v, i) => {
            variations[i] = v;
          });

          let variationItem = Object.values(productsMap[productId]?.items || [])?.find((item) => {
            let isVariantSame = true;
            variations.forEach((variant, index) => {
              if (productsMap?.[item?.id || item]?.[`sel${index + 1}Value`] != variant) {
                isVariantSame = false;
              }
            });
            return isVariantSame;
          });

          if (!variationItem?.id) {
            variationItem = productsMap[variationItem];
          }

          dispatch(
            addPayloadToTempData({
              id: isCustomized[0]?.id,
              data: {
                ...isCustomized[0],
                price:
                  variationItem?.price >= 0
                    ? variationItem?.price
                    : variationItem?.specialPrice || variationItem?.originalPrice,
              },
            })
          );
        }
      }
      onIncrement(e);
    } else if (productObj?.bundleTypeId == 'bundle' && productObj?.typeId == 'simple') {
      // just select default items and add the product into the cart
      const payload = {};
      payload['id'] = productObj?.id;
      payload['catId'] = productObj.categories[0];
      payload['price'] = productObj?.specialPrice || productObj?.originalPrice || 0;
      payload['typeId'] = productObj?.typeId;
      payload['qty'] = 1;

      dispatch(
        addWithoutCalculation({
          ...payload,
          product: productObj,
        })
      );

      dispatch(
        getProductInfo({
          id: productObj.id,
          cluster: clusterId,
          service: defaultAddress?.addressSubType || 'DELIVERY',
          categoryId: productObj.categories[0],
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      ).then((resp) => {
        // add items in payload and dispatch action to update tempCart.customize
        let steps = {};
        for (let step of resp?.payload?.steps || []) {
          let items = {};
          for (let option of step?.options || []) {
            if (option?.default == 1) {
              items[option?.id] = { qty: option?.selectionQty };
            }
          }
          if (Object.keys(items).length > 0) {
            steps[step?.id] = items;
          }
        }

        if (Object.keys(steps).length > 0) {
          dispatch(
            addPayloadToTempData({
              id: payload?.id,
              data: { ...payload, items: steps },
            })
          );
        }
      });
    } else {
      if (productObj?.bundleTypeId == 'bundle' || productObj?.typeId == 'bundle') {
        dispatch(
          getProductInfo({
            id: productObj.id,
            cluster: clusterId,
            service: defaultAddress?.addressSubType || 'DELIVERY',
            categoryId: productObj.categories[0],
            Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
          })
        ).then((resp) => {
          dispatch(
            addProductToCustomize({
              productType: productObj.bundleTypeId,
              updatedOn: new Date().getTime(),
              mainProductId: productObj.id,
              data: isBundleItem
                ? {
                    ...productsMap[mainProductId],
                    category: productsMap[mainProductId].categories[0],
                    noIncrement: true,
                  }
                : {
                    ...(resp.payload?.id ? resp.payload : productObj),
                    category: productObj.categories[0],
                    noIncrement: true,
                  },
            })
          );
          navigate(productRoute, {
            state: {
              retUrl: returnURL,
            },
          });
        });
      } else {
        navigate(productRoute, {
          state: {
            oldLocation: JSON.parse(JSON.stringify(location || {})),
            description: intl.formatMessage({ id: 'customize_your_meals' }),
            retUrl: returnURL,
          },
        });
      }
    }
  };

  if (
    qty == 0 &&
    (productsMap[mainProductId]?.['bundleTypeId'] == 'bundle' ||
      productsMap[mainProductId]?.['bundleTypeId'] == 'bundle_group')
  ) {
    qty = productCustomization?.['bundle']?.[currentStepId]?.[productObj.id]?.qty || 0;
  }

  const decrementBundleItem = () => {
    const newProductCustomization = JSON.parse(JSON.stringify(productCustomization || {}));

    if (productObj?.bundleTypeId == 'bundle' || productObj?.typeId == 'bundle') {
      // handling main product
      const items = cartItems?.data?.items?.filter(
        (item) => item.id === (mainProductId || productObj.id)
      );

      if (items.length > 1) {
        setShowCartDialog(true);
      } else {
        const itemIndex = cartItems?.data?.items?.findIndex(
          (item) => item.id == (mainProductId || productObj.id)
        );
        dispatch(reduceItem({ index: itemIndex }));
      }

      return;
    }

    // handling an item inside a bundle
    let newCustomizationItem = newProductCustomization?.['bundle'];
    if (productsMap[mainProductId]?.typeId == 'simple') {
      newCustomizationItem =
        newProductCustomization?.['items'] || newProductCustomization?.['bundle'];
    }
    if (newCustomizationItem?.[currentStepId]?.[productObj.id]?.qty == 1) {
      delete newCustomizationItem[currentStepId][productObj.id];
    } else {
      newCustomizationItem[currentStepId][productObj.id]['qty'] =
        (newCustomizationItem[currentStepId][productObj.id]['qty'] || 1) - 1;
    }

    if (newCustomizationItem?.[currentStepId]?.[productObj.id]?.qty == 0) {
      delete newCustomizationItem[currentStepId][productObj.id];
    }

    // calculate price to be reduced
    let price = 0;
    let currentVariation, currentProductVariation;
    let variationArray = [-1, -1, -1];

    let stepInfo;
    if (
      productsMap[mainProductId]?.isBOGO ||
      productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
    ) {
      const optionId = parseInt(locationSearch.get('option'));

      let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }
        return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
      });

      if (!bgSteps?.id) {
        bgSteps = productsMap[bgSteps];
      }
      if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
        bgSteps = productsMap[bgSteps?.id];
      }

      stepInfo = bgSteps?.steps?.find((step) => step?.id == currentStepId);
    } else {
      stepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == currentStepId);
    }

    const productInfo = stepInfo?.options?.find((option) => option?.id == productObj?.id);

    let customizationItem = productCustomization?.['bundle'];
    if (productsMap[mainProductId]?.typeId == 'simple') {
      customizationItem = productCustomization?.['items'] || productCustomization?.['bundle'];
    }

    if (customizationItem?.[currentStepId]?.[productObj.id]?.variants) {
      Object.values(customizationItem?.[currentStepId]?.[productObj.id]?.variants).forEach(
        (variant, index) => {
          variationArray[index] = variant;
        }
      );
    } else {
      Object.values(productInfo?.variants || {}).forEach((variant, index) => {
        const selectedOption = variant?.options?.find((option) => option?.isSelected == 1);
        if (selectedOption) {
          variationArray[index] = selectedOption?.id;
        }
      });
    }

    if ((productInfo?.items?.length || 0) < 2 || productInfo?.typeId == 'simple') {
      currentProductVariation = productInfo?.items?.[0] || productInfo;
    } else {
      currentProductVariation = productInfo?.items?.find((item) => {
        let isVariantSame = true;
        variationArray.forEach((variant, index) => {
          if (item[`sel${index + 1}Value`] != variant) {
            isVariantSame = false;
          }
        });
        return isVariantSame;
      });
    }
    for (let step of currentProductVariation?.steps || []) {
      for (let option of step?.options || []) {
        if (option?.subOptions) {
          price +=
            option?.subOptions[
              customizationItem?.[currentStepId]?.[productObj.id]?.items?.[step.id]?.[option.id]?.[
                'qty'
              ] - 1
            ]?.price || 0;
        } else {
          if (
            customizationItem?.[currentStepId]?.[productObj.id]?.items?.[step.id]?.[option.id]?.[
              'qty'
            ]
          ) {
            price +=
              (option?.price || 0) *
              Number(
                customizationItem?.[currentStepId]?.[productObj.id]?.items?.[step.id]?.[
                  option.id
                ]?.['qty'] || 0
              );
          }
        }
      }
    }
    // add base price -
    price +=
      currentProductVariation?.price >= 0
        ? currentProductVariation?.price
        : currentProductVariation?.specialPrice || currentProductVariation?.originalPrice || 0;

    let bogoPrice = 0;
    if (productsMap[mainProductId]?.isBOGO) {
      const items = [];

      for (let step of Object.values(newProductCustomization?.bundle || {})) {
        const itemId = Object.keys(step)[0];

        if (Object.values(step?.[itemId] || {}).length < 1) continue;

        const itemCustomization = Object.values(step)[0];

        const optionId = parseInt(locationSearch.get('option'));
        let productObj = productsMap[newProductCustomization]?.items
          ?.find((item) => item?.id == optionId)
          ?.steps?.[0]?.options?.find((option) => option?.id == itemId);

        if (!productObj) {
          productObj = bogoProducts[optionId]?.find((option) => option?.id == itemId);
        }

        let itemInfo;
        let selectedItemIndex = -1;

        if ((productObj?.items?.length || 0) < 2 || productObj?.typeId == 'simple') {
          selectedItemIndex = 0;
        } else {
          let variationArray = [-1, -1, -1];

          if (Object.values(itemCustomization?.variants || {}).length > 0) {
            Object.values(itemCustomization?.variants || {}).forEach((variant, index) => {
              variationArray[index] = variant;
            });
          } else {
            Object.values(productObj?.variants || {}).forEach((variant, index) => {
              const selectedOption = variant?.options?.find((option) => option?.isSelected == 1);
              if (selectedOption) {
                variationArray[index] = selectedOption?.id;
              }
            });
          }

          productObj.items.forEach((item, i) => {
            let areVariationsSame = true;
            variationArray.forEach((value, index) => {
              if (item[`sel${index + 1}Value`] != value) {
                areVariationsSame = false;
              }
            });

            if (areVariationsSame) {
              selectedItemIndex = i;
            }
          });
        }

        itemInfo = productObj?.items?.[selectedItemIndex];
        if (!itemInfo?.steps?.options) {
          itemInfo =
            productsMap[productObj?.id]?.items?.find((item) => item?.id == itemInfo?.id) ||
            productObj?.items[selectedItemIndex] ||
            itemInfo;
        }
        if (!itemInfo?.id) {
          itemInfo = productsMap[itemInfo];
        }

        let basePrice = 0;
        basePrice +=
          itemInfo?.price >= 0
            ? itemInfo?.price
            : itemInfo?.specialPrice || itemInfo?.originalPrice || 0;

        let extraPrice = 0;

        for (let step of itemInfo?.steps || []) {
          for (let option of step?.options || []) {
            if (option?.subOptions) {
              extraPrice +=
                option?.subOptions[itemCustomization?.items?.[step.id]?.[option.id]?.['qty'] - 1]
                  ?.price || 0;
            } else {
              if (itemCustomization?.items?.[step.id]?.[option.id]?.['qty']) {
                extraPrice +=
                  (option?.price || 0) *
                  Number(itemCustomization?.items?.[step.id]?.[option.id]?.['qty'] || 0);
              }
            }
          }
        }

        items.push({
          id: productObj?.id,
          name: productObj?.name || productObj?.title,
          basePrice: basePrice || 0,
          extraPrice: extraPrice || 0,
        });
      }

      if ((items[0]?.basePrice || 0) == (items[1]?.basePrice || 0)) {
        items.sort(
          (item1, item2) =>
            item2.basePrice + item2.extraPrice - (item1.basePrice + item1.extraPrice)
        );
      } else {
        items.sort((item1, item2) => item2.basePrice - item1.basePrice);
      }

      bogoPrice = items[0]?.basePrice || 0;
      for (let item of items) {
        bogoPrice += item?.extraPrice || 0;
      }
    }

    dispatch(
      updateProductPayload({
        data: {
          ...newProductCustomization,
          price: productsMap[mainProductId]?.isBOGO
            ? bogoPrice * (newProductCustomization?.qty || 1)
            : newProductCustomization['price'] - price * (newProductCustomization?.qty || 1),
        },
      })
    );
    // if (locationSearch.has('cartId')) {
    //   dispatch(
    //     updateWithIndex({
    //       index: locationSearch.get('cartId'),
    //       productPayload: {
    //         ...newProductCustomization,
    //         price: productsMap[mainProductId]?.isBOGO
    //           ? bogoPrice
    //           : newProductCustomization['price'] - price,
    //       },
    //     })
    //   );
    // }

    // window.localStorage.setItem('unlockedStepperId', currentStepId);
  };

  if (isBundleItem) {
    let mainProduct = tempItems?.data?.items?.find((prod) => prod.id == mainProductId);
    let productArray = Object.values(mainProduct?.['bundle'] || {});
    let productCustomizationPayload;

    productArray.forEach((stepObj) => {
      let p = stepObj?.[productObj.id];
      if (Object.keys(p || {}).length > 0) {
        productCustomizationPayload = p;
      }
    });

    // get current variation array
    let selectedVariants = [];
    if (productCustomizationPayload && productCustomizationPayload?.variants) {
      selectedVariants = Object.values(productCustomizationPayload?.variants || {});
    } else {
      const defaultVariationArray = new Array(3).fill(-1);
      for (let variation of productObj?.variants || []) {
        const selectedOption = variation?.options?.find((option) => option?.isSelected == 1)?.id;
        defaultVariationArray[variation?.selIndex - 1] = selectedOption;
      }
      selectedVariants = defaultVariationArray;
    }

    for (let i = 0; i < 3; i++) {
      if (!selectedVariants[i]) selectedVariants[i] = -1;
    }

    // now get the current product item
    let stepInfo;
    if (
      productsMap[mainProductId]?.isBOGO ||
      productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
    ) {
      const optionId = parseInt(locationSearch.get('option'));
      const paramsStepId = parseInt(locationSearch.get('step'));

      let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }

        return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
      });

      if (!bgSteps?.id) {
        bgSteps = productsMap[bgSteps];
      }

      if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
        bgSteps = productsMap[bgSteps?.id];
      }

      stepInfo = bgSteps?.steps?.find((step) => step?.id == (paramsStepId || currentStepId));
    } else {
      stepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == currentStepId);
    }

    const productInfo = stepInfo?.options?.find((option) => option?.id == productObj?.id);

    let currentProductVariation;
    if ((productInfo?.items?.length || 0) < 2 || productInfo?.typeId == 'simple') {
      currentProductVariation = productInfo?.items?.[0] || productInfo;
    } else {
      currentProductVariation = Object.values(productInfo?.items || [])?.find((item) => {
        let isVariantSame = true;
        selectedVariants.forEach((variant, index) => {
          if (productsMap?.[item?.id || item]?.[`sel${index + 1}Value`] != variant) {
            isVariantSame = false;
          }
        });
        return isVariantSame;
      });
    }

    if (!currentProductVariation?.id) {
      currentProductVariation = productsMap[currentProductVariation];
    }

    bundleItemPrice =
      currentProductVariation?.price >= 0
        ? currentProductVariation?.price
        : currentProductVariation?.specialPrice || currentProductVariation?.originalPrice;
  }

  const incrementQty = (e) => {
    const newProductCustomization = JSON.parse(JSON.stringify(productCustomization || {}));
    let totalAdded = Object.values(
      newProductCustomization?.['bundle']?.[currentStepId] || {}
    ).reduce((acc, item) => {
      return acc + (item?.qty || 1);
    }, 0);

    let productConstraints = productsMap[mainProductId]?.constraints?.find(
      (c) => c.id == productObj?.id
    );

    if (
      totalAdded >= (productObj?.maximum || 1) ||
      totalAdded >= parseInt(productConstraints?.maximum || Number.MAX_SAFE_INTEGER)
    ) {
      setAlertMessage(
        intl.formatMessage(
          { id: 'max_quantity_allowed_for_this_step' },
          { count: productConstraints?.maximum || productObj?.maximum }
        )
      );
    } else {
      if (newProductCustomization?.['bundle']?.[currentStepId]?.[productObj?.id]?.qty) {
        newProductCustomization['bundle'][currentStepId][productObj?.id]['qty'] =
          newProductCustomization['bundle'][currentStepId][productObj?.id]['qty'] + 1;
      } else {
        newProductCustomization['bundle'][currentStepId][productObj?.id]['qty'] = 1;
      }

      let itemPrice =
        productObj?.price >= 0
          ? productObj?.price
          : productObj?.specialPrice || productObj?.originalPrice || 0;

      if (itemPrice > 0) {
        newProductCustomization['price'] = newProductCustomization['price'] + itemPrice;
      }

      dispatch(
        updateProductPayload({
          data: { ...newProductCustomization },
        })
      );

      let currentlyAddedItems =
        Object.values(newProductCustomization?.['bundle']?.[currentStepId] || {}).reduce(
          (totalQty, product) => {
            return totalQty + (product?.notAdded ? 0 : product?.qty || 1);
          },
          0
        ) || 0;
      let step = productsMap[mainProductId]?.steps?.find((step) => step.id == stepId);
      let stepIndex = productsMap[mainProductId]?.steps?.findIndex((step) => step.id == stepId);
      let nextStep = productsMap[mainProductId]?.steps?.[stepIndex + 1];
      let minimumRequiredItems = Math.min(step?.minimum || 1, step?.options?.length || 1) || 0;

      if (currentlyAddedItems >= minimumRequiredItems && setCurrentStepperId && nextStep) {
        console.log(`3 setting unlockedStepperId - `, nextStep?.id);
        window.localStorage.setItem('unlockedStepperId', nextStep?.id);
        setCurrentStepperId((prev) => parseInt(nextStep?.id));
      }
    }
  };

  const handleAlertClose = (event, reason) => {
    setAlertMessage('');
  };

  const incrementStepperId = () => {
    let currentlyAddedItems =
      Object.values(productCustomization?.['bundle']?.[currentStepId] || {}).reduce(
        (totalQty, product) => {
          return totalQty + (product?.notAdded ? 0 : product?.qty || 1);
        },
        0
      ) || 0;

    let step;
    let availableSteps;
    let bgSteps;
    if (
      productsMap[mainProductId]?.isBOGO ||
      productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
    ) {
      const optionId = parseInt(locationSearch.get('option'));

      bgSteps = productsMap[mainProductId]?.items?.find((item) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }

        return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
      });

      if (!bgSteps?.id) {
        bgSteps = productsMap[bgSteps];
      }

      if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
        bgSteps = productsMap[bgSteps?.id];
      }

      step = bgSteps?.steps?.find((step) => step?.id == stepId);
      availableSteps = bgSteps?.steps?.filter((s) => !s?.isHidden);
    } else {
      step = productsMap[mainProductId]?.steps?.find((step) => step?.id == stepId);
      availableSteps = productsMap[mainProductId]?.steps?.filter((s) => !s?.isHidden);
    }

    let stepIndex = availableSteps?.findIndex((step) => step.id == stepId);
    let nextStep = availableSteps[stepIndex + 1] || availableSteps[stepIndex];
    let minimumRequiredItems = Math.min(step?.minimum || 1, step?.options?.length || 1) || 0;

    if (currentlyAddedItems >= minimumRequiredItems && setCurrentStepperId && nextStep) {
      window.localStorage.setItem('completedStep', parseInt(stepId));
      console.log(`2 setting - `, nextStep?.id);
      setCurrentStepperId((prev) => parseInt(nextStep?.id));
    }
  };

  let currentStepInfo;
  if (
    productsMap[mainProductId]?.isBOGO ||
    productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
  ) {
    const optionId = parseInt(locationSearch.get('option'));
    const paramsStepId = parseInt(locationSearch.get('step'));

    let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
      let itemInfo;
      if (!item?.id) {
        itemInfo = productsMap[item];
      } else {
        itemInfo = item;
      }

      return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
    });

    if (!bgSteps?.id) {
      bgSteps = productsMap[bgSteps];
    }

    if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
      bgSteps = productsMap[bgSteps?.id];
    }

    currentStepInfo = bgSteps?.steps?.find((step) => step?.id == (paramsStepId || currentStepId));
  } else {
    currentStepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == currentStepId);
  }

  return (
    <React.Fragment>
      <div className={css.addOrRemoveItemWrapper}>
        {qty === 0 ? (
          <React.Fragment>
            {/* <Loader show={load}/> */}
            <div className={css.addToCart}>
              <Button
                disabled={shouldDisabledButton}
                color="primary"
                size="medium"
                fullWidth
                onClick={handleAction}
                {...buttonProps}
              >
                {bundleItemPrice > 0 ? (
                  <FormattedMessage
                    id={'product_add_price'}
                    values={{
                      price: bundleItemPrice,
                      currency: currency,
                    }}
                  />
                ) : (
                  <FormattedMessage id="product_add" defaultMessage="Add" />
                )}
              </Button>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {currentStepInfo?.options?.length === 1 && currentStepInfo?.minimum > 1 ? (
              ''
            ) : (
              <Button
                disable={load}
                variant="outlined"
                className={css.addedTrashBtn}
                onClick={(e) => {
                  if (
                    (productObj['bundleTypeId'] == 'simple' ||
                      productObj['bundleTypeId'] == 'configurable' ||
                      productObj['bundleTypeId'] == 'bundle_group' ||
                      productObj?.isHomePageItem) &&
                    !isBundleItem
                  ) {
                    onDecrement(e);
                  } else {
                    decrementBundleItem();
                  }
                }}
              >
                {qty === 1 ? <img src={deleteIcon} alt="" /> : '-'}
              </Button>
            )}
            {(!mainProductId || productObj?.maximum > 1) &&
            !(currentStepInfo?.options?.length === 1 && currentStepInfo?.minimum > 1) ? (
              <span className={css.addedQty}>{qty > 9 ? qty : `0${qty}`}</span>
            ) : (
              <div className={ClassNames(css.addToCart, css.addedBtn)}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    incrementStepperId();
                  }}
                >
                  <TiTick /> <FormattedMessage id={'added'} defaultMessage={'Added'} />
                </Button>
              </div>
            )}
            {(!mainProductId || productObj?.maximum > 1) &&
              (currentStepInfo?.options?.length === 1 && currentStepInfo?.minimum > 1 ? (
                ''
              ) : (
                <Button
                  disable={load}
                  className={css.plusOneBtn}
                  variant="contained"
                  color="primary"
                  onClick={(e) => {
                    if (productObj['typeId']?.includes('bundle') && itemExistsInCart()) {
                      setShowCustomizeProductDialog(mainProductId || productObj.id);
                    } else if (
                      productObj['bundleTypeId'] == 'simple' ||
                      productObj['bundleTypeId'] == 'configurable'
                    ) {
                      if (isCustomized?.length > 0) {
                        setShowCustomizeProductDialog(mainProductId || productObj.id);
                      } else {
                        onIncrement(e);
                      }
                    } else if (productObj?.maximum > 1) {
                      incrementQty(e);
                    } else {
                      handleAction(e);
                    }
                  }}
                >
                  +
                </Button>
              ))}
          </React.Fragment>
        )}
      </div>
      {alertMessage && (
        <Snackbar
          open={alertMessage?.length > 0}
          autoHideDuration={6000}
          onClose={handleAlertClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert onClose={handleAlertClose} severity="error" sx={{ width: '100%' }}>
            {alertMessage}
          </Alert>
        </Snackbar>
      )}
    </React.Fragment>
  );
};

export default Addtocart;
